import React from 'react';
import { cn } from '@/helpers/classnames';
import { createIcon } from './createIcon';
import { ContainedIcon, ContainedIconProps } from './ContainedIcon';

const Glyph = createIcon(
  'StateChangeGlyph',
  <>
    <path d="M21 17H3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 10L3 7L6 4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 7H21" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 20L21 17L18 14" strokeLinecap="round" strokeLinejoin="round" />
  </>,
);

const StateChange: React.FC<ContainedIconProps> = ({
  className,
  circleClassName,
}) => (
  <ContainedIcon circleClassName={circleClassName}>
    <Glyph className={cn(circleClassName && 'size-4', className)} />
  </ContainedIcon>
);

export default StateChange;
